import ImagesShippingGuide1Svg from '@/public/images/shipping-guide/1.svg';
import ImagesShippingGuide2Svg from '@/public/images/shipping-guide/2.svg';
import ImagesShippingGuide3Svg from '@/public/images/shipping-guide/3.svg';
import ImagesShippingGuideSection1ImgSvg from '@/public/images/shipping-guide/section1-img.svg';
import ImagesShippingGuideSection2Img1Svg from '@/public/images/shipping-guide/section2-img1.svg';
import ImagesShippingGuideSection2Img2Svg from '@/public/images/shipping-guide/section2-img2.svg';
import ImagesShippingGuideSection2Img3Svg from '@/public/images/shipping-guide/section2-img3.svg';
import ImagesShippingGuideSection3IconSvg from '@/public/images/shipping-guide/section3-icon.svg';
import ImagesShippingGuideSection3Img1Svg from '@/public/images/shipping-guide/section3-img1.svg';
import ImagesShippingGuideSection3Img2Svg from '@/public/images/shipping-guide/section3-img2.svg';
import ImagesShippingGuideSection3Img3Svg from '@/public/images/shipping-guide/section3-img3.svg';
import ImagesShippingGuideSection3Img4Svg from '@/public/images/shipping-guide/section3-img4.svg';
import ImagesShippingGuideSection4ImgSvg from '@/public/images/shipping-guide/section4-img.svg';
import ImagesShippingGuideSection5ImgSvg from '@/public/images/shipping-guide/section5-img.svg';
import ImagesShippingGuideSection6ImgSvg from '@/public/images/shipping-guide/section6-img.svg';
import ImagesShippingGuideSection7ImgSvg from '@/public/images/shipping-guide/section7-img.svg';

export {
  ImagesShippingGuide1Svg,
  ImagesShippingGuide2Svg,
  ImagesShippingGuide3Svg,
  ImagesShippingGuideSection1ImgSvg,
  ImagesShippingGuideSection2Img1Svg,
  ImagesShippingGuideSection2Img2Svg,
  ImagesShippingGuideSection2Img3Svg,
  ImagesShippingGuideSection3IconSvg,
  ImagesShippingGuideSection3Img1Svg,
  ImagesShippingGuideSection3Img2Svg,
  ImagesShippingGuideSection3Img3Svg,
  ImagesShippingGuideSection3Img4Svg,
  ImagesShippingGuideSection4ImgSvg,
  ImagesShippingGuideSection5ImgSvg,
  ImagesShippingGuideSection6ImgSvg,
  ImagesShippingGuideSection7ImgSvg,
};
